<div class="grid grid-cols-1 gap-5 md:gap-20 grid-rows-4 md:grid-cols-2 md:grid-rows-2 lg:grid-cols-4 lg:grid-rows-1 justify-center" fxLayout="row wrap">
    @for (step of steps; track $index) {
        <div class="lg:col-start-{{$index+1}} lg:row-start-1 justify-self-center">
            <step-card [title]="step.title | transloco" [content]="step.content | transloco" [number]="$index + 1">
            </step-card>
        </div>
    }
</div>